import React, { Component } from 'react';
import { IonLabel, IonCol, withIonLifeCycle } from '@ionic/react';
import api from '../../../../services/api';
import { synchronizeData } from '../../../../utils/synchronizeData';
import Card from '../../Card';
import Loading from '../../../Loading';

import './style.css';

class CardClientes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      data: null,
    };
  }

  apiCall = () => {
    this.setState({ loading: true });
    api
      .get('/dashboard/cliente')
      .then(({ data }) => {
        this.setState({
          data: data[0],
          loading: false,
        });
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    this.apiCall();
    synchronizeData(this.apiCall);
  }

  render() {
    const { data, loading } = this.state;
    return (
      <>
        <Card
          className="card card__light"
          title="Clientes"
          iconName="icon-cliente"
          dashboardCard>
          {loading ? (
            <Loading />
          ) : (
            <div>
              <IonCol className="main-item">
                <div className="container">
                  <IonLabel color="dark" className="label">
                    Clientes cadastrados:
                  </IonLabel>
                  <IonLabel color="primary" className="value">
                    {data && data.TOTAL_CLIENTES}
                  </IonLabel>
                </div>
              </IonCol>
              <div className="main-section">
                <div className="item">
                  <IonLabel color="dark" className="label">
                    Novos clientes no Mês:
                  </IonLabel>
                  <IonLabel color="primary" className="value">
                    {data && data.TOTAL_CLIENTES_MES}
                  </IonLabel>
                </div>
                <div className="item">
                  <IonLabel color="dark" className="label">
                    Aniversariantes do Mês:
                  </IonLabel>
                  <IonLabel color="primary" className="value">
                    {data && data.TOTAL_CLIENTES_ANIV}
                  </IonLabel>
                </div>
              </div>
            </div>
          )}
        </Card>
      </>
    );
  }
}

export default withIonLifeCycle(CardClientes);
